import styled from "styled-components";

export const ContactStyled = styled.section`
  padding-top: 2em;
`;
